import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "min",
})
export class MinPipe implements PipeTransform {
  transform(items: any[], attr: string): any {
    if (!Array.isArray(items) || items.length === 0) {
      return items;
    }
    if (attr) {
      items.sort((a, b) => a[attr] - b[attr]);
      return items[0][attr];
    } else {
      items.sort((a, b) => a - b);
      return items[0];
    }
  }
}
